// ChatAssistantLogo.js
import React from 'react';
import './Styles/kahramaa.css'
const ChatAssistantLogo = ({ onToggleChat }) => {
  return (
    <button >   
    </button>
  );
};

export default ChatAssistantLogo;